import {
  FHIRMedicationRecommendation,
  fhirMedicationRecommendationSchema,
} from '@eluve/llm-outputs';

/**
 * Stored recommendation data from the database.
 */
interface StoredRecommendation {
  id: string;
  name: string;
  externalRawData?: unknown;
}

/**
 * Converts a stored recommendation from the database to the FHIR format.
 * Handles both new format (full data in externalRawData) and legacy format (name only).
 */
export function convertStoredRecommendationToFHIR(
  stored: StoredRecommendation,
): FHIRMedicationRecommendation {
  // Try to parse full data from externalRawData
  if (stored.externalRawData) {
    const parsed = fhirMedicationRecommendationSchema.safeParse(
      stored.externalRawData,
    );
    if (parsed.success) {
      // Use the stored ID to ensure consistency with the database record
      return { ...parsed.data, id: stored.id };
    }
  }

  // Fallback for legacy data (name only)
  return {
    id: stored.id,
    medication: { name: stored.name },
    citations: [],
  };
}

/**
 * Converts an array of stored recommendations to FHIR format.
 */
export function convertStoredRecommendationsToFHIR(
  storedRecommendations: StoredRecommendation[],
): FHIRMedicationRecommendation[] {
  return storedRecommendations.map(convertStoredRecommendationToFHIR);
}
